import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  list: {
    margin: 0,
    padding: 0,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  listItem: {
    padding: '0px 12px', // Padding interno reduzido conforme você pediu // Espaço entre os itens (cards)
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    backgroundColor: theme.palette.type === 'dark' ? '#27293d' : '#f5f5f5', // Cor de fundo do card
    borderRadius: '8px', // Arredondamento igual ao da imagem
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#32344a' : '#eeeeee'
    },
    // Garante que o item ocupe a largura total
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 6,
    '& .MuiListItemText-multiline':{
      margin: 2,
    }
  },
  mainAttendant: {
    border: `1px solid ${theme.palette.dark_stroke.main}40` // Um destaque sutil para o principal
  },
  title: {
    color: theme.palette.blue_300.main,
    margin: 0
  },
  iconButtonDelete: {
    backgroundColor: 'transparent',
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))
